import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/landing-mobile.jpg'
import _imports_1 from '@/assets/images/landing-mobile@2x.jpg'
import _imports_2 from '@/assets/images/landing-desktop.jpg'
import _imports_3 from '@/assets/images/landing-desktop@2x.jpg'


const _withScopeId = n => (_pushScopeId("data-v-6ddb679d"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = _imports_2 + ' 1x, ' + _imports_3 + ' 2x'
const _hoisted_3 = { class: "sync" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("source", {
    srcset: _hoisted_1,
    media: "(max-width: 1024px)"
  }),
  /*#__PURE__*/_createElementVNode("source", { srcset: _hoisted_2 }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    loading: "lazy"
  })
], -1))
const _hoisted_5 = {
  class: "panel panel--index",
  key: "index"
}
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "panel-body" }
const _hoisted_9 = { class: "sync-code" }
const _hoisted_10 = { class: "instructions" }
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = {
  class: "panel panel--feedback",
  key: "synced"
}
const _hoisted_13 = { class: "panel-body" }
const _hoisted_14 = { class: "icon-synced" }
const _hoisted_15 = { class: "title" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n'
import { useAppState, useNetworkState } from '@/services/composition';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const nwState = useNetworkState()
const { state, send } = useAppState()

const roomid = computed(() => {
  return nwState.value.context.roomid
})

const isSynced = computed(() => {
  return state.value.matches('sync.synced')
})

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_Transition, {
          name: "medium-fade",
          mode: "out-in",
          appear: ""
        }, {
          default: _withCtx(() => [
            (!_unref(isSynced))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('sync.xr.title')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(roomid)), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('sync.xr.info')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(t)('sync.xr.reload')) + " ", 1),
                    _createVNode(_component_ui_btn, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(send)('RELOAD_SYNC_CODE');})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('sync.xr.refresh')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ui_icon, { name: "checkmark" })
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('sync.synced')), 1),
                    _createVNode(_component_ui_btn, {
                      variant: "secondary",
                      color: "light",
                      "border-position": "bottom-right",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('sync.xr.enter_vr')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})